import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

interface CommunityMember {
  email?: string;
  name?: string;
}

export interface AccessGroupMemberConfirmationCardProps {
  access_group: {
    name?: string;
    description?: string;
    member_count?: number;
    spaces_count?: number;
  };
  community_members?: CommunityMember[];
}

export const AccessGroupMemberConfirmationCard = ({
  access_group,
  community_members = [],
}: AccessGroupMemberConfirmationCardProps) => {
  const accessGroupAttributes = [
    {
      label: t("help_widget.copilot.confirmation_card.access_group_name"),
      value: access_group.name,
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.access_group_description",
      ),
      value: access_group.description,
    },
    {
      label: t("help_widget.copilot.confirmation_card.number_of_members"),
      value: access_group.member_count,
    },
    {
      label: t("help_widget.copilot.confirmation_card.number_of_spaces"),
      value: access_group.spaces_count,
    },
  ];

  const communityMemberGroups = community_members.map(community_member => [
    {
      label: t("help_widget.copilot.confirmation_card.community_member_name"),
      value: community_member.name,
    },
    {
      label: t("help_widget.copilot.confirmation_card.community_member_email"),
      value: community_member.email,
    },
  ]);

  return (
    <ConfirmationCardLayout
      title={t(
        "help_widget.copilot.confirmation_card.title_access_group_members",
      )}
      attributes={[accessGroupAttributes, ...communityMemberGroups]}
    />
  );
};
